import React from 'react';
import createReactClass from 'create-react-class';
import { Form, registerField } from 'core/forms';

const FormFieldObject = createReactClass({

  onUpdateField({ update }) {
    var value = (this.props.value || {});
    var newValue = { ...value, ...update };
    
    this.props.updateField(newValue);
  },

  render() {

    const { schema, fieldId } = this.props;

    const value = this.props.value || {};
    
    return (
      <div>
        <Form
            onUpdate={this.onUpdateField}
            schema={schema.subSchema}
            model={value}
            fieldId={fieldId}
        />
      </div>
    );
  }
})

registerField('Object', React.memo(FormFieldObject));

export default FormFieldObject;
